module.exports = __webpack_public_path__ + "static/media/pH_results.1bf7d167.webp";